import { useState } from 'react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { toast } from 'react-toastify';
import SummaryApi from '../common';
import displayNPRCurrency from '../helpers/displayCurrency';
import { request } from '../helpers/request';
import AdminEditProduct from './AdminEditProduct';

const AdminProductCard = ({
    data,
    fetchdata
}) => {
    const [editProduct, setEditProduct] = useState(false)

    const handleDeleteProduct = async (e) => {
        e.stopPropagation();
        if (window.confirm("Are you sure you want to delete this product?")) {
            try {
                const response = await request(SummaryApi.deleteProduct, {
                    body: JSON.stringify({ _id: data?._id })
                });

                const responseData = await response.json();

                if (responseData.success) {
                    toast.success(responseData.message);
                    fetchdata();
                } else {
                    toast.error(responseData.message);
                }
            } catch (error) {
                console.error("Delete error:", error);
                toast.error("Failed to delete product");
            }
        }
    }

    return (
        <div className='bg-white rounded-[1.5rem] md:rounded-[2rem] border border-surface-border overflow-hidden shadow-sm hover:shadow-premium transition-all duration-500 group flex flex-col h-full relative'>
            
            {/* Action Buttons - Desktop Hover / Mobile Visible */}
            <div className='absolute top-3 right-3 md:top-4 md:right-4 z-10 flex flex-col gap-2 md:opacity-0 md:group-hover:opacity-100 transition-all duration-300 md:translate-x-4 md:group-hover:translate-x-0'>
                <button 
                    onClick={() => setEditProduct(true)}
                    className='w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-xl bg-white/90 backdrop-blur-md text-slate-600 hover:bg-primary hover:text-white transition-all shadow-lg border border-slate-100 active:scale-90'
                    title="Edit Product"
                >
                    <FaEdit className='text-sm md:text-base' />
                </button>
                <button 
                    onClick={handleDeleteProduct}
                    className='w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-xl bg-white/90 backdrop-blur-md text-red-500 hover:bg-red-500 hover:text-white transition-all shadow-lg border border-slate-100 active:scale-90'
                    title="Delete Product"
                >
                    <FaTrash className='text-sm md:text-base' />
                </button>
            </div>

            <div className='relative h-40 md:h-48 bg-surface-muted flex items-center justify-center p-4 md:p-6 overflow-hidden'>
                <div className='absolute inset-0 bg-gradient-to-br from-white/20 to-transparent' />
                <img 
                    src={data?.productImage[0]} 
                    className='h-full object-contain mix-blend-multiply transition-transform duration-500 group-hover:scale-110' 
                    alt={data?.productName}
                />
            </div>
            
            <div className='p-4 md:p-6 flex flex-col flex-1 bg-white'>
                <div className='flex items-center justify-between mb-1.5 md:mb-2'>
                     <p className='text-[8px] md:text-[10px] font-black text-gray-400 border-l-2 border-accent/30 pl-2 uppercase tracking-widest'>{data?.category}</p>
                     <span className='text-[8px] md:text-[10px] bg-surface-muted px-2 py-0.5 rounded-full font-bold text-gray-500'>{data?.brandName}</span>
                </div>
                
                <h3 className='font-bold text-primary text-sm md:text-base line-clamp-2 leading-tight mb-3 md:mb-4 flex-1 group-hover:text-accent transition-colors'>
                    {data.productName}
                </h3>
                
                <div className='flex items-center justify-between mt-auto pt-2'>
                    <div className='flex flex-col'>
                        <span className='text-xs md:text-sm font-black text-gray-400 line-through opacity-50'>{displayNPRCurrency(data.price)}</span>
                        <span className='text-base md:text-lg font-black text-primary tracking-tight'>{displayNPRCurrency(data.sellingPrice)}</span>
                    </div>
                </div>
            </div>

            {editProduct && (
                <AdminEditProduct productData={data} onClose={() => setEditProduct(false)} fetchdata={fetchdata} />
            )}
        </div>
    )
}

export default AdminProductCard
